"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var __1 = require("..");
var CopyButton_1 = __importDefault(require("../../../widgets/CopyButton"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b;
    return (0, core_1.createStyles)({
        drawerTitleDiv: (_a = {
                marginBottom: theme.spacing(6.5),
                marginTop: theme.spacing(1.5)
            },
            _a[theme.breakpoints.up('md')] = {
                alignItems: 'center',
                marginTop: 0,
            },
            _a),
        copyButtonWrapper: {
            marginLeft: -8,
            overflow: 'hidden',
        },
        headerText: (_b = {
                marginBottom: '6px'
            },
            _b[theme.breakpoints.up('md')] = {
                marginTop: '6px',
            },
            _b),
    });
});
function DrawerHeader(_a) {
    var title = _a.title;
    var classes = useStyles();
    var shortUrl = (0, __1.useDrawerState)().relevantShortLink || '';
    var theme = (0, core_1.useTheme)();
    var isMobileView = (0, core_1.useMediaQuery)(theme.breakpoints.down('sm'));
    return (react_1.default.createElement("div", { className: classes.drawerTitleDiv },
        react_1.default.createElement(core_1.Typography, { variant: isMobileView ? 'h6' : 'h3', color: "primary", className: classes.headerText }, title),
        react_1.default.createElement("div", { className: classes.copyButtonWrapper },
            react_1.default.createElement(CopyButton_1.default, { shortUrl: shortUrl, iconSize: 20 }))));
}
exports.default = DrawerHeader;
